// extracted by mini-css-extract-plugin
export default {"anchor":"styles__anchor_____XRl"};